import { TYPE_INDEXATION_POURCENTAGE } from '@/configuration/baux/contrat/contratConf';

export default function calculMontantIndexe(ech, montantActuel) {
  if (ech.typeIndexation === TYPE_INDEXATION_POURCENTAGE) {
    return montantActuel * (1 + ech.valeurIndexationActuel / 100);
  }
  return (ech.montantIndexationReference / ech.valeurIndexationReference)
    * ech.valeurIndexationActuel;
}
